import { EncryptionKeys } from "controllers/EncryptionController"
import { NAME_LOCALSTORAGE } from "constants/localStorage"
import { getStoreData, Stores } from "services/indexedDB"
import { runtimeKeyStore } from "stores/runtimeKeyStore"

export const addKeyToLocalStorageObject = (
  type:
    | EncryptionKeys.conversationEncryptionKeys
    | EncryptionKeys.projectEncryptionKeys
    | EncryptionKeys.buildAdditionalInfoEncryptionKeys,
  additional: Record<string, string>
) => {
  if (type === EncryptionKeys.projectEncryptionKeys) {
    runtimeKeyStore.upsertProjectKeys(additional)
  } else if (type === EncryptionKeys.conversationEncryptionKeys) {
    runtimeKeyStore.upsertConversationKeys(additional)
  } else if (type === EncryptionKeys.buildAdditionalInfoEncryptionKeys) {
    runtimeKeyStore.upsertBuildKeys(additional)
  }
}

export const getUserVaultKey = (): string =>
  localStorage.getItem(EncryptionKeys.userVaultKey) || ""
export const setUserVaultKey = (value: string): void => {
  localStorage.setItem(EncryptionKeys.userVaultKey, value)
}
export const removeUserVaultKey = (): void => {
  localStorage.removeItem(EncryptionKeys.userVaultKey)
}

export const getTimezone = (): string => localStorage.getItem("timezone") || ""
export const setTimezone = (value: string): void => {
  localStorage.setItem("timezone", value)
}

export const getUserId = (): string => localStorage.getItem("user_id") || ""
export const setUserId = (value: string): void => {
  localStorage.setItem("user_id", value)
}

export const getUserMasterKey = (): string =>
  localStorage.getItem(EncryptionKeys.userMasterKey) || ""
export const setUserMasterKey = (value: string): void => {
  localStorage.setItem(EncryptionKeys.userMasterKey, value)
}

export const getUserEmail = (): string =>
  localStorage.getItem("userEmail") || ""
export const setUserEmail = (value: string): void => {
  localStorage.setItem("userEmail", value)
}
export const removeUserEmail = (): void => {
  localStorage.removeItem("userEmail")
}

export const getUserFullName = (): string =>
  localStorage.getItem("userFullName") || ""
export const setUserFullName = (value: string): void => {
  localStorage.setItem("userFullName", value)
}
export const removeUserFullName = (): void => {
  localStorage.removeItem("userFullName")
}

export const getEnabledEncrypted = (): string =>
  localStorage.getItem("enabled_encrypted") || ""
export const setEnabledEncrypted = (value: string): void => {
  localStorage.setItem("enabled_encrypted", value)
}
export const removeEnabledEncrypted = (): void => {
  localStorage.removeItem("enabled_encrypted")
}

export const getAccessToken = (): string =>
  localStorage.getItem("access_token") || ""
export const setAccessToken = (value: string): void => {
  localStorage.setItem("access_token", value)
}

export const getTokenType = (): string =>
  localStorage.getItem("token_type") || ""
export const setTokenType = (value: string): void => {
  localStorage.setItem("token_type", value)
}

export const getLastWsDataByTabId = (tabId: string): string =>
  localStorage.getItem(`last_ws_data_${tabId}`) || ""
export const setLastWsDataByTabId = (tabId: string, value: string): void => {
  localStorage.setItem(`last_ws_data_${tabId}`, value)
}
export const getSharedProject = (): string =>
  localStorage.getItem("sharedProject") || "{}"
export const setSharedProject = (value: string): void => {
  localStorage.setItem("sharedProject", value)
}
export const removeSharedProject = (): void => {
  localStorage.removeItem("sharedProject")
}
export const getIsDoneSyncConversationNote = (): string =>
  localStorage.getItem("isDoneSyncConversationNote") || ""
export const setIsDoneSyncConversationNote = (value: string): void => {
  localStorage.setItem("isDoneSyncConversationNote", value)
}
export const removeIsDoneSyncConversationNote = (): void => {
  localStorage.removeItem("isDoneSyncConversationNote")
}
export const getRemindMeLater = (): string =>
  localStorage.getItem(NAME_LOCALSTORAGE.REMIND_ME_LATER) || ""
export const setRemindMeLater = (value: string): void => {
  localStorage.setItem(NAME_LOCALSTORAGE.REMIND_ME_LATER, value)
}
export const removeRemindMeLater = (): void => {
  localStorage.removeItem(NAME_LOCALSTORAGE.REMIND_ME_LATER)
}
export const getNewOrganization = (): string =>
  localStorage.getItem(NAME_LOCALSTORAGE.NEW_ORGANIZATION) || ""
export const setNewOrganization = (value: string): void => {
  localStorage.setItem(NAME_LOCALSTORAGE.NEW_ORGANIZATION, value)
}
export const removeNewOrganization = (): void => {
  localStorage.removeItem(NAME_LOCALSTORAGE.NEW_ORGANIZATION)
}
export const clearLocalStorage = (): void => {
  localStorage.clear()
}

export const getPrivateKeyStores = async (userId: string): Promise<string> => {
  const privateKeyStores = await getStoreData<{
    id: string
    privateKey: string
  }>(Stores.PrivateKeys)
  return privateKeyStores.find((el) => el.id === userId)?.privateKey || ""
}
